import Image from 'next/image';

// Re-export as OptimizedImage for consistency
export default Image;
